import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import { addCities, clearState, fetchCities } from "../../redux/Slices/CitiesSlice";
import { validateFieldLanguage } from "../../Utils/languageValidation";

const AddCity = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name_ar: "",
    name_en: "",
    status: "",
    shipping_price: 0,
  });

  const { cities, isLoading: loading, error, success } = useSelector((state) => state.cities);

  useEffect(() => {
    dispatch(clearState());
    if (!cities || !cities.data || cities.data.length === 0) {
      dispatch(fetchCities({ page: 1, per_page: 100 }));
    }
  }, [dispatch, cities]);

  useEffect(() => {
    if (success) {
      toast.success("تمت الإضافة بنجاح");
      dispatch(clearState());
      navigate("/cities");
    }
    if (error) {
      toast.error("لم تتم الإضافة");
      dispatch(clearState());
    }
  }, [success, error, dispatch, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // BUG-30 fix: التحقق من لغة الحقول
    const arError = validateFieldLanguage(formData.name_ar, "ar");
    if (arError) return toast.error(arError);
    const enError = validateFieldLanguage(formData.name_en, "en");
    if (enError) return toast.error(enError);

    // BUG-29 fix: منع سعر التوصيل السالب
    if (parseFloat(formData.shipping_price) < 0) {
      return toast.error("سعر التوصيل لا يمكن أن يكون قيمة سالبة");
    }

    // التحقق من عدم تكرار اسم المدينة (عربي أو إنجليزي)
    const isDuplicateAr = cities && Array.isArray(cities.data) && cities.data.some(
      (c) => c.name_ar.trim().toLowerCase() === formData.name_ar.trim().toLowerCase()
    );
    if (isDuplicateAr) {
      return toast.error("اسم المدينة بالعربي مكرر بالفعل");
    }

    const isDuplicateEn = cities && Array.isArray(cities.data) && cities.data.some(
      (c) => c.name_en.trim().toLowerCase() === formData.name_en.trim().toLowerCase()
    );
    if (isDuplicateEn) {
      return toast.error("اسم المدينة بالإنجليزي مكرر بالفعل");
    }

    dispatch(clearState());
    dispatch(addCities(formData));
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div style={{ padding: "4px 0", direction: "rtl" }}>
      <style>{`
        .city-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .city-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      {/* ── Header ─────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20, display: "flex", alignItems: "center", gap: 8 }}>
            🏙 إضافة مدينة جديدة
          </h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>إنشاء مدينة أو محافظة توصيل جديدة وتعيين تكلفة الشحن الافتراضية لها</p>
        </div>
        <Link to="/cities" className="text-decoration-none">
          <button style={{ display: "flex", alignItems: "center", gap: 7, padding: "9px 18px", borderRadius: 10, border: "1px solid #cbd5e1", background: "#fff", color: "#475569", fontWeight: 700, cursor: "pointer", fontSize: 14 }}>
            <FaArrowLeft size={12} /> العودة
          </button>
        </Link>
      </div>

      {/* ── Form Card ─────────────────────────────────── */}
      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "24px 30px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>اسم المدينة (عربي) *</label>
              <input
                type="text"
                style={inputStyle}
                name="name_ar"
                value={formData.name_ar}
                onChange={handleInputChange}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="مثال: القاهرة..."
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>اسم المدينة (إنجليزي) *</label>
              <input
                type="text"
                style={inputStyle}
                name="name_en"
                value={formData.name_en}
                onChange={handleInputChange}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="مثال: Cairo..."
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>سعر الشحن والتوصيل (ج.م) *</label>
              <input
                type="number"
                style={inputStyle}
                name="shipping_price"
                value={formData.shipping_price}
                onChange={handleInputChange}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل سعر شحن الكتب والمطبوعات"
                required
                min="0"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={labelStyle}>حالة التفعيل *</label>
              <select
                className="city-custom-select"
                name="status"
                value={formData.status ? String(formData.status) : ""}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>اختر الحالة</option>
                <option value="0">غير مفعل</option>
                <option value="1">مفعل</option>
              </select>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #f1f5f9", marginTop: 20, paddingTop: 20 }}>
            <button type="button" onClick={() => navigate("/cities")} style={{ padding: "9px 22px", borderRadius: 9, border: "1px solid #cbd5e1", background: "#fff", color: "#475569", fontWeight: 700, cursor: "pointer" }}>إلغاء</button>
            <button type="submit" disabled={loading} style={{ padding: "9px 28px", borderRadius: 9, border: "none", background: "linear-gradient(135deg,var(--main-color),var(--main-light))", color: "#fff", fontWeight: 700, cursor: "pointer" }}>
              {loading ? 'جاري الحفظ...' : 'إضافة المدينة'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCity;
